import { Md5 } from 'ts-md5';

export const getGravatar = (key: string): string => {
  const hash = Md5.hashStr(key?.toString()?.toLocaleLowerCase().trim() || '');

  return `https://www.gravatar.com/avatar/${hash}?d=retro`;
};
